exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".answer {\n  list-style: none;\n  display: inline-block;\n  padding: 1px 0px 0px 0px;\n}\n.list-answers {\n  width: 80%;\n}", ""]);

// exports
